import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import cn from "classnames";

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  rounded?: boolean;
  size?: "sm" | "md" | "lg";
  error?: string;
  icon?: ReactNode;
  inputClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { className, rounded, size = "md", error, icon, disabled, inputClassName, ...otherProps } = props;

  const inputSizeClassName = {
    sm: "px-4 py-2.5 h-10",
    md: "px-4 py-3 h-14",
    lg: "px-4 py-3",
  };

  return (
    <div className={cn(["relative w-full", className])}>
      {icon}
      <input
        ref={ref}
        disabled={disabled}
        className={cn([
          "font-inter w-full rounded-lg border border-[#d9d9d9] px-4 py-3 text-base leading-[100%] transition-all duration-200 outline-none hover:not-disabled:border-[var(--sonic-silver)] focus:not-disabled:border-[var(--sonic-silver)]",
          rounded && "rounded-[32px]",
          inputSizeClassName[size],
          error && "border-[#c00f0c] bg-[#fee9e7] text-[#ec221f] hover:border-[#c00f0c] focus:border-[#c00f0c]",
          disabled && "cursor-not-allowed opacity-40 hover:border-[#d9d9d9] focus:border-[#d9d9d9]",
          inputClassName,
        ])}
        {...otherProps}
      />
    </div>
  );
});
